import PageContent from './page-content.vue';

export default PageContent;
